import './index.css';
import React from 'react';
import { connect } from 'react-redux';
import {destroyDialog, setisLoading} from '../../../actions/app';
import Dialog from '../../lib/dialog/index';

const Message = ({ dialog, destroyDialog, setisLoading }) => (
  dialog.map((item, index) => (
    <Dialog
      key={index}
      closable={true}
      visible={true}
      onClose={() => {destroyDialog(item.id);setisLoading(false)}}>
        <p className="store-dialog-title">提示</p>
        <p className="mcycle-error-dialog-msg">{item.msg}</p>
    </Dialog>
  ))
)

export default connect(
  state => ({
    dialog: state.app.dialog
  }),
  {destroyDialog, setisLoading}
)(Message);


// WEBPACK FOOTER //
// ./src/components/common/message/index.js